'use strict';

/* globals window $ Resources */

window.addEventListener('mainJsLoaded', function (event) {
    careerInit();
});

function careerInit() {
    // Application form validation
    var $careerForm = $('#js-careerForm'),
        validator = $careerForm.validate(),
        $phone = $careerForm.find('.phone_field'),
        $country = $careerForm.find('.country_field');

    // intlPhone init
    window.vbqUtils.phoneCodes.init($country, $phone);

    // Custom rule which ensures only PDFs are allowed, and that the filename does not contain special characters
    $.validator.addMethod('myfile', function (value, element, param) {
        return value.match(/(?:^|\/|\\)((?:[a-z0-9_\-\. ])+\.(?:pdf))$/i);
    }, Resources.CAREER_FILE_LIMITATION);

    $careerForm.find('[type="file"]').rules('add', {required: true, myfile: true});

    window.vbqUtils.validationLogic.formValidation($careerForm);

    // File input custom validation
    $careerForm.find('[type="file"]').on('change', function () {
        validator.element($(this));
    });

    // reCaptcha init
    window.vbqUtils.recaptchaHelper.init();

    // Submit event
    $careerForm.on('submit', function () {
        var $form = $(this);

        // do not submit if the form is not valid
        if (!$form.valid()) {
            return;
        }

        // Force update since it's not a normal submit
        if ($phone.parent().hasClass('iti')) {
            $phone.siblings('input').val(window.intlTelInputGlobals.getInstance($phone[0]).getNumber());
        }

        $('#js-careerLoader').show();
    });

    $(function() {
        // Update the selects on load if values have been previously set
        var $careerCountries = $('.career-countries'),
            $careerCities = $('.career-cities'),
            $dwfrmCareerCountry = $('#dwfrm_career_country'),
            $dwfrmCareerCity = $('#dwfrm_career_city');

        $careerCountries.trigger('change');
        $dwfrmCareerCountry.trigger('change');

        // Disable the city selects when no country is selected
        if ($careerCities.val() == '' && $careerCountries.val() == '') {
            $careerCities.attr('disabled', 'disabled');
        }
        if ($dwfrmCareerCity.val() == '' && $dwfrmCareerCountry.val() == '') {
            $dwfrmCareerCity.attr('disabled', 'disabled');
        }

        // Scroll to file error if present
        var $firstErrorElement = $careerForm.find('.gl_has-error');
        if ($firstErrorElement.length > 0) {
            window.vbqUtils.cache.$window.scrollTop($firstErrorElement.offset().top);
        }
    });

    // Disable the application city select when no country is selected, and filter only the country's cities
    window.vbqUtils.cache.$body.on('change', '#dwfrm_career_country', function () {
        var $country = $('#dwfrm_career_country'),
            $city = $('#dwfrm_career_city'),
            city = $city.val(),
            cityExists = false;

        if ($country.val() == '') {
            $city.attr('disabled', 'disabled');
        }
        else {
            $city.removeAttr('disabled');

            var countryCode = $country.val();

            $city.find('option').each(function() {
                var $this = $(this);

                if ($this.val().split('_')[0] == countryCode || $this.val() == 'Others') { // Always allow the 'Others' option
                    $this.show();

                    if ($this.val() == city) {
                        cityExists = true;
                    }
                }
                else {
                    $this.hide();
                }
            });

            // Reset the selected city value if it has changed
            if (!cityExists) {
                $city.val('');
            }
        }
    });

    // Offers filters change
    window.vbqUtils.cache.$body.on('change', '.offers-content select', function () {
        var country = $('.career-countries').val(),
            city = $('.career-cities').val(),
            dept = $('.career-departments').val(),
            formData = $(this).parents('form').serialize(),
            viewAll = window.location.href.indexOf('va=1') > -1 ? '?va=1' : '';

        $('#js-careerLoader').show();

        $.ajax({
            type: 'GET',
            url: window.Urls.updateCareerFilters,
            data: formData
        }).done(function (data) {
            $('.offers-form').html(data);

            var $careerCities = $('.career-cities');

            // Set back the select values
            $('.career-countries').val(country);
            $('.career-cities').val(city);
            $('.career-departments').val(dept);

            // Disable the city select when no country is selected
            if (city == '' && country == '') {
                $careerCities.attr('disabled', 'disabled');
            }
            else {
                $careerCities.removeAttr('disabled');
            }

            // Update the offers list
            $.ajax({
                type: 'GET',
                url: window.Urls.updateCareerOffersList + viewAll,
                data: formData
            }).done(function (data) {
                $('.offers-list').html(data);
                $('#js-careerLoader').hide();
            }).fail(function () {
                $('#js-careerLoader').hide();
            });
        }).fail(function () {
            $('#js-careerLoader').hide();
        });
    });

    // Offers paging clicks
    window.vbqUtils.cache.$body.on('click', '.career-paging-item a', function (e) {
        e.preventDefault();

        var url = $(this).attr('href');

        $.ajax({
            type: 'GET',
            url: url,
            data: $('.offers-form').serialize(),
            success: function (data) {
                $('.offers-list').html(data);
            }
        });
    });

    // Reset offers filters
    $('#js-careerResetFilters').on('click', function (e) {
        e.preventDefault();

        $('.career-countries').val('');
        $('.career-cities').val('');
        $('.career-departments').val('').trigger('change');
    });

    var $careerHomeStoreCarousel = $('#js-careerHomeStoreCarousel'),
        interval;

    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('fromDesktop'),
            enter: function () {
                $careerHomeStoreCarousel.slick('unslick');

                interval = window.setInterval(function () {
                    if ($careerHomeStoreCarousel.find('.lazyload').length === 0) {
                        $careerHomeStoreCarousel.slick({
                            slidesToShow: 1,
                            dots: false,
                            arrows: true,
                            swipe: true
                        });
                        window.clearInterval(interval);
                    }
                }, 250);
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobileAndTablet'),
            enter: function () {
                $careerHomeStoreCarousel.slick('unslick');

                interval = window.setInterval(function () {
                    if ($careerHomeStoreCarousel.find('.lazyload').length === 0) {
                        $careerHomeStoreCarousel.slick({
                            slidesToShow: 1,
                            dots: true,
                            arrows: false,
                            swipe: true
                        });
                        window.clearInterval(interval);
                    }
                }, 250);
            }
        }
    ]);
}
